export const getDefaultValues = (gameFeeDetails) => ({
  GameEntryFeeAmount: gameFeeDetails?.GameEntryFeeAmount || '',
  GameEntryFeeDurationTime: gameFeeDetails?.GameEntryFeeDurationTime || '',
  GameEntryFeeIsActive: !gameFeeDetails?.GameEntryFeeIsActive || '',
});
